<template>
  <v-chart
    v-loading="loading"
    style="width: 100%;height: 100%"
    :options="scatterDetailOptions"
    :autoresize="true"
    :init-options="{ devicePixelRatio: 1 }"
  ></v-chart>
</template>

<script>
import { GraphAnalysisRecordApi } from '@wiz-api/graph-analysis'

const graphAnalysisRecordApi = new GraphAnalysisRecordApi()

export default {
  data() {
    return {
      loading: false,
      scatterDetailData: {},
      scatterDetailOptions: {},
      graph: [],
    }
  },
  mounted() {},
  methods: {
    // 初始化
    async initData(code) {
      await this.getDetailData(code)
      // x,y轴名称
      const [...xyName] = this.graph
      if (xyName.length <= 1) {
        xyName[1] = { ...xyName[0] }
      } else {
        xyName[2] = { ...xyName[0] }
        xyName[3] = { ...xyName[1] }
      }

      const scatterPlotOptions = this.scatterDetailData.scatterDetailOptions.scatterPlotOptions
      if (scatterPlotOptions) {
        this.scatterDetailOptions = {
          ...scatterPlotOptions,
          title: {
            ...scatterPlotOptions.title,
            show: false,
          },
          legend: {
            show: false,
            type: 'scroll',
            data: [],
            itemWidth: 13,
            itemHeight: 13,
            textStyle: {
              color: '#fff',
              fontSize: 12,
            },
            padding: 0,
            itemGap: 5,
          },
          grid: {
            ...scatterPlotOptions.grid,
            top: 10,
            right: 20,
            bottom: 20,
          },
          tooltip: {
            appendToBody: true,
            trigger: 'item',
            axisPointer: {
              type: 'cross',
              crossStyle: { color: '#666' },
            },
            textStyle: {
              color: '#101010',
              fontSize: 12,
            },
            borderColor: '#ccc',
            borderWidth: 1,
            backgroundColor: '#ffffffee',
            formatter(params) {
              const color = params.color
              const colorSpan = `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${color};"></span>`
              return `${colorSpan}${params.seriesName}<br>${params.value[2]}<br>(X) ${
                xyName[params.seriesIndex].XName
              }：${params.value[0]}<br>(Y) ${xyName[params.seriesIndex].YName}：${params.value[1]}`
            // ${params.value[3] ? `<br>趋势线：${params.value[3]}` : ''}
            },
          },

          dataZoom: [
            {
              type: 'slider',
              show: true,
              xAxisIndex: 0,
              filterMode: 'none',
              height: 15,
              bottom: 0,
              textStyle: {
                color: 'rgba(255,255,255,0.6)',
              },
              borderColor: 'transparent',
              backgroundColor: 'rgb(49,98,135,0.3)',
              fillerColor: 'rgba(78,144,252,0.4)',
            },
            {
              type: 'slider',
              show: true,
              right: 0,
              yAxisIndex: 0,
              filterMode: 'none',
              width: 15,
              textStyle: {
                color: 'rgba(255,255,255,0.6)',
              },
              borderColor: 'transparent',
              backgroundColor: 'rgb(49,98,135,0.3)',
              fillerColor: 'rgba(78,144,252,0.4)',
            },
            // {
            //   type: 'inside',
            //   xAxisIndex: 0,
            //   filterMode: 'none',
            // },
            // {
            //   type: 'inside',
            //   yAxisIndex: 0,
            //   filterMode: 'none',
            // },
          ],
          xAxis: {
            ...scatterPlotOptions.xAxis,
            // min(val) {
            //   return Math.round(val.min - (val.max - val.min) * 0.1)
            // }, // 自适应数据最小值
            // max(val) {
            //   return Math.round(val.max + (val.max - val.min) * 0.1)
            // }, // 自适应数据最大值
            axisLabel: {
              formatter(value) {
                return Math.round(value)
              },
            },
          },
          yAxis: {
            ...scatterPlotOptions.yAxis,
            // min(val) {
            //   return Math.round(val.min - (val.max - val.min) * 0.1)
            // }, // 自适应数据最小值
            // max(val) {
            //   return Math.round(val.max + (val.max - val.min) * 0.1)
            // }, // 自适应数据最大值
            axisLabel: {
              formatter(value) {
                return Math.round(value)
              },
            },
          },
          series: scatterPlotOptions.series.map((item) => {
            return {
              ...item,
              symbolSize: item.type === 'scatter' ? 8 : item.symbolSize,
              lineStyle: item.type === 'line' ? { ...item.lineStyle, width: 4 } : item.lineStyle,
            }
          }),
        }
      }
      // xy区间
      this.scatterDetailOptions.xAxis.min =
      this.scatterDetailData.xAxisMinValue || this.scatterDetailData.xAxisMinValue === 0
        ? this.scatterDetailData.xAxisMinValue
        : (val) => {
          return Math.round(val.min - (val.max - val.min) * 0.1)
        }
      this.scatterDetailOptions.xAxis.max =
      this.scatterDetailData.xAxisMaxValue || this.scatterDetailData.xAxisMaxValue === 0
        ? this.scatterDetailData.xAxisMaxValue
        : (val) => {
          return Math.ceil(val.max + (val.max - val.min) * 0.1)
        }
      this.scatterDetailOptions.yAxis.min =
      this.scatterDetailData.yAxisMinValue || this.scatterDetailData.yAxisMinValue === 0
        ? this.scatterDetailData.yAxisMinValue
        : (val) => {
          return Math.round(val.min - (val.max - val.min) * 0.1)
        }
      this.scatterDetailOptions.yAxis.max =
      this.scatterDetailData.yAxisMaxValue || this.scatterDetailData.yAxisMaxValue === 0
        ? this.scatterDetailData.yAxisMaxValue
        : (val) => {
          return Math.ceil(val.max + (val.max - val.min) * 0.1)
        }
      // 处理图例数据
      const arr = this.getLegendData(this.scatterDetailOptions.series)
      arr.forEach((item, index) => {
        this.scatterDetailOptions.legend.data.push(item)
      // if (index !== arr.length - 1) this.scatterDetailOptions.legend.data.push('')
      })
      this.scatterDetailOptions.legend.data = this.scatterDetailOptions.legend.data.flat()
    },
    // 处理图例数据
    getLegendData(arr) {
      const aobj = {}
      arr.forEach((item) => {
        if (aobj[item.titleSort]) {
          // aobj[item.titleSort] = []
          aobj[item.titleSort].push(item.name)
        } else {
          aobj[item.titleSort] = [item.name]
        }
      })
      return Object.values(aobj)
    },
    // 详情图表信息
    async getDetailData(code) {
      try {
        this.loading = true
        const [error, res] = await graphAnalysisRecordApi.getByDeviceCode({
          deviceCode: code
        })
        this.scatterDetailData = res
        this.scatterDetailData.scatterDetailOptions = this.processData(res)
        // this.scatterDetailData.graphDataJson = JSON.parse(res.graphDataJson)
        this.graph = JSON.parse(res.graphDataJson)
        this.loading = false
      } catch (error) {
        console.log('查询详情失败', error)
      }
    },
    // 返回数据的处理方法
    processData(elem) {
      let graphDataJson
      try {
        graphDataJson = JSON.parse(elem.graphDataJson)
      } catch (err) {
        console.error('Failed to parse graphDataJson', err)
        return {}
      }
      if (!graphDataJson || graphDataJson.length <= 0) {
        return {}
      }

      const scatterObj = {}
      // const lineHighObj = {}
      // const lineLowerObj = {}
      const YPredictObj = {}
      const seriesArr = []
      const seriesColor = [
        '#3357FF', // 亮蓝
        '#A133FF', // 亮紫
        '#33FF57', // 亮绿
        '#FF5733', // 亮橙
        '#FF33A1', // 亮粉
        '#FFD700', // 金色
        '#00CED1', // 暗绿松石
      ]
      const lineColor = [
        '#00BFFF88', // 深天蓝
        '#9932CC88', // 暗紫
        '#00FF7F88', // 春绿
        '#FF450088', // 橙红
        '#FF69B488', // 热粉
        '#FFD70088', // 金色
        '#00CED188', // 暗绿松石
        '#FF149388', // 深粉
        '#8B451388', // 深棕
      ]

      // 处理单个表格数据
      graphDataJson.forEach((data, index) => {
        scatterObj[`scatterArr${index + 1}`] = data.IotData.map((scatterData) => {
          return [scatterData.X, scatterData.Y, scatterData.Datetime, scatterData.Predict]
        })
        YPredictObj[`YPredictArr${index + 1}`] = data.IotData.map((scatterData) => {
          return [scatterData.X, scatterData.Predict, scatterData.Datetime]
        })
        // lineHighObj[`lineHighArr${index + 1}`] = data.IotData.map((scatterData) => {
        //   return [scatterData.X, scatterData.HighThreshold]
        // })
        // lineLowerObj[`lineLowerArr${index + 1}`] = data.IotData.map((scatterData) => {
        //   return [scatterData.X, scatterData.LowerThreshold]
        // })
      })

      const scatterArr = Object.keys(scatterObj)
      // const lineHighArr = Object.keys(lineHighObj)
      // const lineLowerArr = Object.keys(lineLowerObj)
      const YPredictArr = Object.keys(YPredictObj)

      // 添加散点图数据
      scatterArr.forEach((ite, index) => {
        if (index !== 0) {
          seriesColor.shift()
        }
        seriesArr.push({
          titleSort: `${index + 1}`,
          type: 'scatter',
          name: graphDataJson[index].LegendName,
          data: scatterObj[ite],
          symbolSize: 2,
          animation: true,
          itemStyle: {
            color: seriesColor[0],
          },
        })
      })

      // 添加趋势线线数据
      YPredictArr.forEach((ite, index) => {
        seriesArr.push({
          titleSort: `${index + 1}`,
          name: `${graphDataJson[index].LegendName}-趋势线`,
          type: 'line',
          symbol: 'circle',
          symbolSize: 4,
          itemStyle: {
            normal: {
              color: `${lineColor[index + 2]}`,
            },
          },
          smooth: true,
          zlevel: -1,
          lineStyle: {
            // type: 'dotted',
            width: 2,
          },
          color: `${lineColor[index + 2]}`,
          data: YPredictObj[ite],
        })
      })

      // // 添加上阈值线数据
      // lineHighArr.forEach((ite, index) => {
      //   seriesArr.push({
      //     titleSort: `${index + 1}`,
      //     name: `${graphDataJson[index].LegendName}上阈值`,
      //     type: 'line',
      //     symbol: 'none',
      //     smooth: true,
      //     lineStyle: {
      //       // type: 'dotted',
      //       width: 1,
      //     },
      //     color: `${lineColor[index]}`,
      //     data: lineHighObj[ite],
      //   })
      // })

      // // 添加下阈值线数据
      // lineLowerArr.forEach((ite, index) => {
      //   seriesArr.push({
      //     titleSort: `${index + 1}`,
      //     name: `${graphDataJson[index].LegendName}下阈值`,
      //     type: 'line',
      //     symbol: 'none',
      //     smooth: true,
      //     lineStyle: {
      //       width: 1,
      //     },
      //     color: `${lineColor[index]}`,
      //     data: lineLowerObj[ite],
      //   })
      // })

      // 格式化生成时间
      const generationTime = this.dayjs(elem.generationTime).format('YYYY-MM-DD HH:mm:ss')

      // 构建图表配置对象
      const obj = {
        scatterPlotOptions: {
          title: {
            id: elem.id,
            text: `${elem.graphName}-${generationTime}`,
            show: true,
            left: 'center',
            fontSize: 12,
            top: 10,
            textStyle: {
              fontSize: 12,
              color: '#101010',
              fontWeight: 500,
              lineHeight: 14,
              height: 14,
            },
          },
          grid: {
            top: '25%',
            left: '3%',
            right: '4%',
            bottom: '5%',
            containLabel: true,
          },
          xAxis: {
            show: true,
            type: 'value',
            nameTextStyle: {
              color: '#101010',
              width: 100,
              overflow: 'breakAll',
            },
            splitLine: {
              lineStyle: {
                color: '#b6545480',
              },
            },
            axisLine: {
              lineStyle: {
                color: '#1db1ea',
              },
            },
            min(val) {
              return Math.round(val.min - (val.max - val.min) * 0.1)
            }, // 自适应数据最小值
            max(val) {
              return Math.round(val.max + (val.max - val.min) * 0.1)
            }, // 自适应数据最大值
            axisLabel: {
              formatter(value) {
                return Math.round(value)
              },
            },
          },
          yAxis: {
            show: true,
            type: 'value',
            nameTextStyle: {
              color: '#101010',
              width: 100,
              overflow: 'breakAll',
            },
            splitLine: {
              lineStyle: {
                color: '#b6545480',
              },
            },
            axisLine: {
              lineStyle: {
                color: '#1db1ea',
              },
            },
            min(val) {
              return Math.round(val.min - (val.max - val.min) * 0.1)
            }, // 自适应数据最小值
            max(val) {
              return Math.round(val.max + (val.max - val.min) * 0.1)
            }, // 自适应数据最大值
            axisLabel: {
              formatter(value) {
                return Math.round(value)
              },
            },
          },
          series: seriesArr,
        },
      }
      return obj
    },
  },
}
</script>

<style lang="scss" scoped></style>
